import { Api_url } from '../../common/api_url'
import { API_XANO_BASE_URL } from '../../config/api_config'
import { axiosAuth, axiosNoAuth } from '../../config/axiosInstances'
import { SET_COMPLETE_CHALLENGE_BANNER, SET_COMPLETE_QUIZ_BANNER, SET_DOWNLOAD_CERTIFICATE_BANNER, SET_EXTEND_CHALLENGE_BANNER, SET_JES_CALCULATED_BANNER, SET_JES_IS_NOT_CALCULATED_BANNER, SET_START_CHALLENGE_BANNER, SET_UNLOCK_CERTIFICATE_BANNER, SET_UPGRADE_BANNER, SET_USER_DATA_FOR_BANNER } from './types'
// import { SET_USER_DATA_FOR_BANNER } from './types'

export function getUserDataForAdBanner(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetAdBannerData, {
                params: {
                    user_id
                }
            })
            // console.log(response.data);

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getUserActiveChallengeForNotification(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActiveChallengesForNotification, {
                params: {
                    user_id
                }
            })
            // console.log(response.data);

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}


export function getNotificationData(user_id , successCallback ,errorCallback){
    return async function (dispatch){
        try{
            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetNotificationData , {
                params : {
                    user_id
                }
            })

            dispatch({type: SET_USER_DATA_FOR_BANNER, payload:{...response.data , cache_time : Date.now() + 60 * 60 * 1000} });
            successCallback && successCallback(response.data);

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function setShowCompleteQuizBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_COMPLETE_QUIZ_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function setShowStartChallengeBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_START_CHALLENGE_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function setShowCompleteChallengeBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_COMPLETE_CHALLENGE_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function setShowExtendChallengeBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_EXTEND_CHALLENGE_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function setShowJesIsNotCalculatedBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_JES_IS_NOT_CALCULATED_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function setShowJesCalculatedBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_JES_CALCULATED_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function setShowDownloadCertificateBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_DOWNLOAD_CERTIFICATE_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function setShowUnlockCertificateBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_UNLOCK_CERTIFICATE_BANNER, payload: value})

        }
       
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function setShowUpgradeBanner(value, successCallback ,errorCallback){
    return async function (dispatch){
        try{
          
            dispatch({type: SET_UPGRADE_BANNER, payload: value})

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}


